"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserDataFromToken = exports.anonymousUserData = void 0;

var _jwtDecode2 = _interopRequireDefault(require("jwt-decode"));

var webAnonymousData = function webAnonymousData() {
  return {
    userId: 'anonymousId',
    fullName: null,
    email: null
  };
};

var mobileAnonymousData = function mobileAnonymousData() {
  return {
    userId: 'anonymousId',
    fullName: null,
    email: null
  };
};

var webUserData = function webUserData() {
  return {
    user: {
      userId: 'web ',
      fullName: 'web ',
      email: 'web '
    }
  };
};

var mobileUserData = function mobileUserData() {
  return {
    user: {
      userId: 'anonymousId',
      fullName: null,
      email: null
    }
  };
};

var anonymousUserData = function anonymousUserData(provider) {
  if (provider === 'mobile') {
    return mobileAnonymousData();
  }

  return webAnonymousData();
};

exports.anonymousUserData = anonymousUserData;

var getUserDataFromToken = function getUserDataFromToken(token) {
  try {
    var _jwtDecode = (0, _jwtDecode2["default"])(token),
        userId = _jwtDecode.userId,
        accountId = _jwtDecode.accountId,
        email = _jwtDecode.email,
        fullName = _jwtDecode.fullName,
        requester = _jwtDecode.requester;

    return {
      userId: userId,
      accountId: accountId,
      email: email,
      fullName: fullName,
      requester: requester
    };
  } catch (e) {
    return undefined;
  }
};

exports.getUserDataFromToken = getUserDataFromToken;